import { gql } from '@apollo/client';

/**
 * Signs the Support admin for admins. It can write to every channel, so pages using it must
 * not offer sending. Admin rights are what let GetStream search users by name.
 */
export const GET_CHAT_TOKEN = gql`
  query BoGetChatToken {
    getChatToken
  }
`;
